// 设备管理
const order = [ {
  path: 'Order/OrderList',
  name: 'OrderList',
  component: resolve => require(['@/components/Order/OrderList'], resolve)
}]

const label = [{
  path: 'Label/LabelList',
  name: 'LabelList',
  component: resolve => require(['@/components/Label/LabelList'], resolve)
}, {
  path: 'Label/PrintLabel',
  name: 'PrintLabel',
  component: resolve => require(['@/components/Label/Components/PrintLabel.vue'], resolve)
}, {
  path: 'Label/CreatLabel',
  name: 'CreatLabel',
  component: resolve => require(['@/components/Label/CreatLabel'], resolve)
}]

const manage = [{
  path: 'Manage/ManageList',
  name: 'ManageList',
  component: resolve => require(['@/components/Manage/ManageList'], resolve)
}]

export {
  order,
  label,
  manage
}



// WEBPACK FOOTER //
// ./src/router/router.js